import axios from "axios";
import { getApiUrl } from "../../Config";
import { getAuthHeader } from "./auth";

// The management API returns a presigned S3 URL as a (sometimes quoted) text
// body. Use a bare axios instance so the kubb client interceptors don't apply;
// auth headers are attached explicitly.
const loadPresignedUrl = async (url: string): Promise<string> => {
  const response = await axios.create().get<string>(`${getApiUrl()}${url}`, {
    headers: await getAuthHeader(),
    responseType: "text",
  });
  return response.data.replace(/['"]+/g, "");
};

export const loadFileFromApi = async (url: string): Promise<void> => {
  window.open(await loadPresignedUrl(url), "_blank");
};

export const loadFileFromApiToMemory = async (url: string): Promise<any> => {
  const presignedUrl = await loadPresignedUrl(url);
  return axios.create().get(presignedUrl, { responseType: "blob" });
};
